import { render } from "./BuildcraftIcon.vue?vue&type=template&id=b484ac68&scoped=true"
import script from "./BuildcraftIcon.vue?vue&type=script&lang=js"
export * from "./BuildcraftIcon.vue?vue&type=script&lang=js"

import "./BuildcraftIcon.vue?vue&type=style&index=0&id=b484ac68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b484ac68"]])

export default __exports__